import './Footer.css';

const LOGO_URL = 'https://eightfold.ai/wp-content/uploads/logo_alt.svg';

export default function Footer() {
  return (
    <footer className="app-footer">
      <span className="footer-text">
        Powered by
        <img src={LOGO_URL} alt="Eightfold.ai" className="footer-logo" />
        <span className="footer-hashtag">#Whatsnextforyou</span>
      </span>
    </footer>
  );
}
